import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@osmix/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@osmix/ui/dialog";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Textarea } from "@/components/ui/textarea";

// Инициация возврата/спора покупателем (fd-order-19). Причина — свободный
// текст (обязателен), тип — возврат или спор. Заявку рассматривает продавец
// либо администратор; здесь покупатель только её подаёт.
export function ReturnRequestDialog(t0) {
  const $ = _c(103);
  const {
    open,
    onOpenChange,
    onSubmit,
    submitting: t1
  } = t0;
  const submitting = t1 === undefined ? false : t1;
  const {
    t
  } = useTranslation();
  const [kind, setKind] = useState("return");
  const [reason, setReason] = useState("");
  const [touched, setTouched] = useState(false);
  let t2;
  let t3;
  if ($[0] !== open) {
    t2 = () => {
      if (open) {
        setKind("return");
        setReason("");
        setTouched(false);
      }
    };
    t3 = [open];
    $[0] = open;
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  const valid = reason.trim().length > 0;
  let t4;
  if ($[3] !== kind || $[4] !== onSubmit || $[5] !== reason || $[6] !== submitting || $[7] !== valid) {
    t4 = async () => {
      setTouched(true);
      if (!valid || submitting) {
        return;
      }
      await onSubmit({
        kind,
        reason: reason.trim()
      });
    };
    $[3] = kind;
    $[4] = onSubmit;
    $[5] = reason;
    $[6] = submitting;
    $[7] = valid;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const submit = t4;
  let t5;
  if ($[9] !== t) {
    t5 = t("returns.dialogTitle");
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = <DialogTitle>{t5}</DialogTitle>;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t) {
    t7 = t("returns.dialogHint");
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t7) {
    t8 = <DialogDescription>{t7}</DialogDescription>;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t6 || $[18] !== t8) {
    t9 = <DialogHeader>{t6}{t8}</DialogHeader>;
    $[17] = t6;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t) {
    t10 = t("returns.kindLabel");
    $[20] = t;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10) {
    t11 = <span className="type-body2-bold text-osmix-text-1">{t10}</span>;
    $[22] = t10;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = value => setKind(value as "return" | "dispute");
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <RadioGroupItem value="return" id="return-kind-return" className="mt-0.5" />;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t) {
    t14 = t("returns.kind.return");
    $[26] = t;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t14) {
    t15 = <span className="block type-body2-bold text-osmix-text-1">{t14}</span>;
    $[28] = t14;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== t) {
    t16 = t("returns.kindReturnHint");
    $[30] = t;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== t16) {
    t17 = <span className="block type-small text-osmix-text-2">{t16}</span>;
    $[32] = t16;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] !== t15 || $[35] !== t17) {
    t18 = <label className="flex cursor-pointer items-start gap-3 rounded-xl border border-osmix-gray-200 p-3">{t13}<span>{t15}{t17}</span></label>;
    $[34] = t15;
    $[35] = t17;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <RadioGroupItem value="dispute" id="return-kind-dispute" className="mt-0.5" />;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  let t20;
  if ($[38] !== t) {
    t20 = t("returns.kind.dispute");
    $[38] = t;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  let t21;
  if ($[40] !== t20) {
    t21 = <span className="block type-body2-bold text-osmix-text-1">{t20}</span>;
    $[40] = t20;
    $[41] = t21;
  } else {
    t21 = $[41];
  }
  let t22;
  if ($[42] !== t) {
    t22 = t("returns.kindDisputeHint");
    $[42] = t;
    $[43] = t22;
  } else {
    t22 = $[43];
  }
  let t23;
  if ($[44] !== t22) {
    t23 = <span className="block type-small text-osmix-text-2">{t22}</span>;
    $[44] = t22;
    $[45] = t23;
  } else {
    t23 = $[45];
  }
  let t24;
  if ($[46] !== t21 || $[47] !== t23) {
    t24 = <label className="flex cursor-pointer items-start gap-3 rounded-xl border border-osmix-gray-200 p-3">{t19}<span>{t21}{t23}</span></label>;
    $[46] = t21;
    $[47] = t23;
    $[48] = t24;
  } else {
    t24 = $[48];
  }
  let t25;
  if ($[49] !== kind || $[50] !== t18 || $[51] !== t24) {
    t25 = <RadioGroup value={kind} onValueChange={t12} className="gap-2">{t18}{t24}</RadioGroup>;
    $[49] = kind;
    $[50] = t18;
    $[51] = t24;
    $[52] = t25;
  } else {
    t25 = $[52];
  }
  let t26;
  if ($[53] !== t11 || $[54] !== t25) {
    t26 = <div className="flex flex-col gap-2">{t11}{t25}</div>;
    $[53] = t11;
    $[54] = t25;
    $[55] = t26;
  } else {
    t26 = $[55];
  }
  let t27;
  if ($[56] !== t) {
    t27 = t("returns.reasonLabel");
    $[56] = t;
    $[57] = t27;
  } else {
    t27 = $[57];
  }
  let t28;
  if ($[58] !== t27) {
    t28 = <span className="type-body2-bold text-osmix-text-1">{t27}</span>;
    $[58] = t27;
    $[59] = t28;
  } else {
    t28 = $[59];
  }
  let t29;
  let t30;
  if ($[60] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = event => setReason(event.target.value);
    t30 = () => setTouched(true);
    $[60] = t29;
    $[61] = t30;
  } else {
    t29 = $[60];
    t30 = $[61];
  }
  let t31;
  if ($[62] !== t) {
    t31 = t("returns.reasonPlaceholder");
    $[62] = t;
    $[63] = t31;
  } else {
    t31 = $[63];
  }
  let t32;
  if ($[64] !== reason || $[65] !== t31) {
    t32 = <Textarea value={reason} onChange={t29} onBlur={t30} placeholder={t31} rows={4} />;
    $[64] = reason;
    $[65] = t31;
    $[66] = t32;
  } else {
    t32 = $[66];
  }
  let t33;
  if ($[67] !== t || $[68] !== touched || $[69] !== valid) {
    t33 = touched && !valid && <span className="type-small text-status-rejected">{t("returns.reasonRequired")}</span>;
    $[67] = t;
    $[68] = touched;
    $[69] = valid;
    $[70] = t33;
  } else {
    t33 = $[70];
  }
  let t34;
  if ($[71] !== t28 || $[72] !== t32 || $[73] !== t33) {
    t34 = <label className="flex flex-col gap-2">{t28}{t32}{t33}</label>;
    $[71] = t28;
    $[72] = t32;
    $[73] = t33;
    $[74] = t34;
  } else {
    t34 = $[74];
  }
  let t35;
  if ($[75] !== t26 || $[76] !== t34) {
    t35 = <div className="flex flex-col gap-5">{t26}{t34}</div>;
    $[75] = t26;
    $[76] = t34;
    $[77] = t35;
  } else {
    t35 = $[77];
  }
  let t36;
  if ($[78] !== onOpenChange) {
    t36 = () => onOpenChange(false);
    $[78] = onOpenChange;
    $[79] = t36;
  } else {
    t36 = $[79];
  }
  let t37;
  if ($[80] !== t) {
    t37 = t("common.cancel");
    $[80] = t;
    $[81] = t37;
  } else {
    t37 = $[81];
  }
  let t38;
  if ($[82] !== t36 || $[83] !== t37) {
    t38 = <Button type="button" variant="osmix-outline" size="pill" onClick={t36}>{t37}</Button>;
    $[82] = t36;
    $[83] = t37;
    $[84] = t38;
  } else {
    t38 = $[84];
  }
  let t39;
  if ($[85] !== submitting || $[86] !== t) {
    t39 = submitting ? t("checkout.processing") : t("returns.submit");
    $[85] = submitting;
    $[86] = t;
    $[87] = t39;
  } else {
    t39 = $[87];
  }
  let t40;
  if ($[88] !== submit || $[89] !== submitting || $[90] !== t39) {
    t40 = <Button type="button" variant="osmix-filled" size="pill" onClick={submit} disabled={submitting}>{t39}</Button>;
    $[88] = submit;
    $[89] = submitting;
    $[90] = t39;
    $[91] = t40;
  } else {
    t40 = $[91];
  }
  let t41;
  if ($[92] !== t38 || $[93] !== t40) {
    t41 = <DialogFooter>{t38}{t40}</DialogFooter>;
    $[92] = t38;
    $[93] = t40;
    $[94] = t41;
  } else {
    t41 = $[94];
  }
  let t42;
  if ($[95] !== t35 || $[96] !== t41 || $[97] !== t9) {
    t42 = <DialogContent className="max-h-[90vh] overflow-auto rounded-2xl sm:max-w-lg">{t9}{t35}{t41}</DialogContent>;
    $[95] = t35;
    $[96] = t41;
    $[97] = t9;
    $[98] = t42;
  } else {
    t42 = $[98];
  }
  let t43;
  if ($[99] !== onOpenChange || $[100] !== open || $[101] !== t42) {
    t43 = <Dialog open={open} onOpenChange={onOpenChange}>{t42}</Dialog>;
    $[99] = onOpenChange;
    $[100] = open;
    $[101] = t42;
    $[102] = t43;
  } else {
    t43 = $[102];
  }
  return t43;
}